import styled, { css } from 'styled-components';
import { StyledDialogActionButton } from 'components/AlertDialog/style';

export const Style = {
  ReviewModalForm: styled('div')(({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.s4};
  `),
  FormRow: styled('div')<{ $isDisabled?: boolean }>(({ theme, $isDisabled }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.s6};
    min-height: 40px;

    ${$isDisabled && css`
      > span:first-child,
      .MuiButton-root {
        opacity: 0.5;
      }
    `}
  `),
  FormLabel: styled('span')(({ theme }) => css`
    width: 180px;
    flex-shrink: 0;
    color: ${theme.palette.N200};
    ${theme.typography.Body2};
  `),
  FormValue: styled('span')(({ theme }) => css`
    flex: 1;
    color: ${theme.palette.N75};
    ${theme.typography.Body2};
  `),
  FormControl: styled('div')(() => css`
    flex: 1;
  `),
  RadioGroup: styled('div')(({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.s6};
  `),
  RadioOption: styled('label')(({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacing.s2};
    cursor: pointer;
    color: ${theme.palette.N75};
    ${theme.typography.Body2};
  `),
  RadioInput: styled('input')(({ theme }) => css`
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: ${theme.palette.ACYPrimaryMainLight};
    cursor: pointer;
  `),
  ReviewModalActions: styled('div')(({ theme }) => css`
    display: flex;
    width: 100%;
    gap: ${theme.spacing.s4};
  `),
  ReviewModalCancelButton: styled(StyledDialogActionButton)(({ theme }) => css`
    flex: 1;
    border: 1px solid ${theme.palette.ACYPrimaryMainLight};
    background-color: transparent;
    color: ${theme.palette.ACYPrimaryMainLight};
    border-radius: 24px;
    padding: ${theme.spacing.s3} ${theme.spacing.s6};

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `),
  ReviewModalSaveButton: styled(StyledDialogActionButton)(({ theme }) => css`
    flex: 1;
    border-radius: 24px;
    padding: ${theme.spacing.s3} ${theme.spacing.s6};
    background-color: ${theme.palette.ACYPrimaryMainLight};
    color: ${theme.palette.N700};

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `),
  RejectCommentDropdown: styled('div')<{ $isDisabled?: boolean }>(({ theme, $isDisabled }) => css`
    width: 100%;
    max-width: 360px;
    border: 1px solid ${theme.palette.N500};
    border-radius: 8px;
    ${$isDisabled && 'cursor: not-allowed;'}
  `)
};
